import Expense from './expense';

export type { ExpenseArgs } from './expense';

export default Expense;
